import { FormField2, IDynamicFormValue, ISelectOption } from 'src/lib';

const getLocalFiltersPayload = (
  filterValues: IDynamicFormValue,
  formFields: FormField2[]
): IDynamicFormValue =>
  formFields
    .map((field) => {
      if (field.control_type === 'SINGLESELECT-DROPDOWN') {
        const [value] = filterValues[field.name] as ISelectOption[];
        return {
          [field.name]: value
        };
      }
      return {
        [field.name]: filterValues[field.name]
      };
    })
    .reduce((acc, curr) => ({ ...acc, ...curr }), {});

export default getLocalFiltersPayload;
